__turbopack_context__.v({
  "compatibleWith": "CompatibleWith-module-scss-module__l12Rsa__compatibleWith",
  "teaser": "CompatibleWith-module-scss-module__l12Rsa__teaser",
  "teaserArrow": "CompatibleWith-module-scss-module__l12Rsa__teaserArrow",
  "teaserThumb": "CompatibleWith-module-scss-module__l12Rsa__teaserThumb",
  "teaserThumbs": "CompatibleWith-module-scss-module__l12Rsa__teaserThumbs",
});
